import { useTranslation } from 'react-i18next';
import type { Website } from './api';

/** «B · r9», «C · сбой» (a failed build), or «—». */
export function useVariantLabel(): (site: Website) => string {
  const { t } = useTranslation('sites');
  const { t: tc } = useTranslation('common');
  return (site) => {
    const v = site.variant;
    if (!v) return tc('dash');
    // `variant` is the API's label («B · r9»); a failed build carries only the key.
    if (site.variant_failed) return t('variant.failed', { key: v.slice(0, 1) });
    return v;
  };
}
